/* eslint-disable radix */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-useless-return */
import React from 'react';
import Grid from '@material-ui/core/Grid';
import {
  Button,
  CircularProgress,
  TextField,
  Typography,
} from '@material-ui/core';
import firebase from 'config/config';
import swal from 'sweetalert';

const buttonStyles = {
  background: '#3366FF',
  color: 'white',
  fontSize: '12px',
  textTransform: 'capitalize',
};
const editButtonStyles = {
  background: '#AFB2B7',
  color: 'black',
  fontSize: '12px',
  textTransform: 'capitalize',
};
const AdvancePaymentTerms = ({ activeRole, selectedTruckerData }) => {
  const {
    trucker_id: truckerId,
    company_name: truckerName,
    blacklist,
    advance_terms_days: advanceDays,
    advance_terms_percentage: advancePercentage,
  } = selectedTruckerData || {};
  const db = firebase.firestore();
  const userDetails = firebase.auth().currentUser;
  const auditLog = firebase.functions().httpsCallable('utilities-auditLog');
  const [numberOfDays, setNumberOfDays] = React.useState(advanceDays);
  const [percentage, setPercentage] = React.useState(advancePercentage);
  const [isToBeEdited, setIsToBeEdited] = React.useState(advancePercentage);
  const [updating, setUpdating] = React.useState(false);
  const handleTextChangeForDays = e => {
    const regex = /^[0-9]*$/;
    if (regex.test(e.target.value)) {
      setNumberOfDays(e.target.value);
    } else return;
  };
  const handleTextChangeForPercent = e => {
    const regex = /^\d*\.?\d*$/;
    if (regex.test(e.target.value) && e.target.value < 101) {
      setPercentage(e.target.value);
    } else return;
  };
  const handleSubmitNumberOfLocations = () => {
    setUpdating(true);
    const truckerRef = db.collection('Truckers').doc(truckerId);

    // Set the "capital" field of the city 'DC'
    return truckerRef
      .update({
        advanceTermsDays: parseInt(numberOfDays),
        advanceTermsPercentage: percentage,
        modifiedAt: new Date(),
      })
      .then(() => {
        setUpdating(false);
        swal(
          'Success!',
          `You have set ${numberOfDays} as Number Of Days & ${percentage}% percentage as Advance Payment Terms for  ${truckerName} `,
          'success'
        );
        setIsToBeEdited(true);
        const auditBody = {
          collection: 'Truckers',
          numberOfLocationsSetBy: userDetails?.uid,
          type: 'Updated Advance Payments of Terms in Truckers',
          message: `${userDetails?.email} in Truckers collection inside ${truckerId} set  ${numberOfDays} as Number Of Days & ${percentage}% percentage as Advance Payment Terms  `,
          uploadedAt: new Date(),
        };
        auditLog(auditBody);
      })
      .catch(error => {
        // The document probably doesn't exist.
        setUpdating(false);
        swal('Error!', `Something went wrong`, 'error');
      });
  };
  return (
    <div>
      <Typography
        variant="subtitle2"
        gutterBottom
        style={{ textTransform: 'capitalize', marginBottom: '10px' }}
      >
        Advance Payment Terms
      </Typography>
      <Grid
        container
        spacing={1}
        direction="row"
        justifyContent="center"
        alignItems="center"
      >
        <Grid
          item
          xs={
            (activeRole === 'ops' ||
              activeRole === 'finance' ||
              activeRole === 'approval') &&
            !blacklist
              ? 5
              : 6
          }
        >
          {activeRole === 'sales' ||
          activeRole === 'branch-ops' ||
          activeRole === 'traffic' ||
          activeRole === 'partner-exec-manager' ? (
            <TextField
              size="small"
              id="outlined-basic"
              variant="outlined"
              fullWidth
              value={numberOfDays}
              disabled
            />
          ) : (
            <TextField
              size="small"
              id="outlined-basic"
              variant="outlined"
              value={numberOfDays}
              fullWidth
              placeholder="0-10 days"
              disabled={isToBeEdited || blacklist}
              onChange={handleTextChangeForDays}
            />
          )}
        </Grid>
        <Grid
          item
          xs={
            (activeRole === 'ops' ||
              activeRole === 'finance' ||
              activeRole === 'approval') &&
            !blacklist
              ? 5
              : 6
          }
        >
          {activeRole === 'sales' ||
          activeRole === 'branch-ops' ||
          activeRole === 'traffic' ||
          activeRole === 'partner-exec-manager' ? (
            <TextField
              size="small"
              id="outlined-basic"
              variant="outlined"
              fullWidth
              value={percentage}
              disabled
            />
          ) : (
            <TextField
              size="small"
              id="outlined-basic"
              variant="outlined"
              value={percentage}
              fullWidth
              placeholder="%"
              disabled={isToBeEdited || blacklist}
              onChange={handleTextChangeForPercent}
            />
          )}
        </Grid>
        {(activeRole === 'ops' ||
          activeRole === 'finance' ||
          activeRole === 'approval') &&
        !blacklist ? (
          <Grid item xs={2}>
            {isToBeEdited ? (
              <Button
                size="small"
                variant="contained"
                style={editButtonStyles}
                onClick={() => {
                  setIsToBeEdited(false);
                }}
              >
                Edit
              </Button>
            ) : updating ? (
              <CircularProgress size={20} />
            ) : (
              <Button
                size="small"
                variant="contained"
                style={buttonStyles}
                onClick={handleSubmitNumberOfLocations}
                disabled={!percentage || !numberOfDays}
              >
                Submit
              </Button>
            )}
          </Grid>
        ) : null}
      </Grid>
    </div>
  );
};

export default AdvancePaymentTerms;
